import { render, staticRenderFns } from "./ItemDaBusca.vue?vue&type=template&id=b658ac84"
import script from "./ItemDaBusca.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemDaBusca.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports